/**
 * PDP sticky cart bar — direct add + variant picker.
 * Uses document-level delegation so it keeps working after color swatch swaps replace #cart-bar.
 */
(function () {
  var initialized = false;

  function getCartAddUrl() {
    var bar = document.getElementById('cart-bar');
    if (bar && bar.dataset.cartAddUrl) return bar.dataset.cartAddUrl;
    if (window.theme && window.theme.routes && window.theme.routes.cart_add_url) {
      return window.theme.routes.cart_add_url;
    }
    return '/cart/add';
  }

  function getPopup() {
    return document.querySelector('[data-cart-bar-variant-picker-popup]');
  }

  function getPickerBtn() {
    var bar = document.getElementById('cart-bar');
    return bar ? bar.querySelector('[data-cart-bar-variant-picker]') : null;
  }

  function positionPopupAboveCartBar() {
    var cartBar = document.getElementById('cart-bar');
    var popup = getPopup();
    if (!cartBar || !popup) return;
    var gap = 8;
    var barHeight = cartBar.offsetHeight || 80;
    popup.style.bottom =
      'calc(' + barHeight + 'px + ' + gap + 'px + env(safe-area-inset-bottom, 0px))';
  }

  function setPickerOpen(isOpen) {
    var popup = getPopup();
    var pickerBtn = getPickerBtn();
    var cartBar = document.getElementById('cart-bar');
    if (!popup || !pickerBtn) return;

    popup.hidden = !isOpen;
    pickerBtn.setAttribute('aria-expanded', String(isOpen));
    if (isOpen) positionPopupAboveCartBar();
    if (cartBar) cartBar.classList.toggle('cart-bar--picker-open', isOpen);
  }

  function resetPickerItemStates() {
    var popup = getPopup();
    if (!popup) return;
    popup.querySelectorAll('.cart-bar__variant-picker__item').forEach(function (b) {
      b.classList.remove('is-loading', 'has-error');
    });
  }

  function cartBarFetchAdd(form, triggerBtn, onSuccess) {
    if (!form || !triggerBtn || triggerBtn.disabled || triggerBtn.classList.contains('is-loading')) {
      return;
    }

    triggerBtn.classList.add('is-loading');
    triggerBtn.setAttribute('disabled', 'disabled');

    fetch(getCartAddUrl(), {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/javascript'
      },
      body: new FormData(form)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) throw data;
          return data;
        });
      })
      .then(function (data) {
        triggerBtn.classList.remove('is-loading');
        triggerBtn.removeAttribute('disabled');
        if (onSuccess) onSuccess(data);
      })
      .catch(function (err) {
        console.error('cart-bar add failed', err);
        triggerBtn.classList.remove('is-loading');
        triggerBtn.removeAttribute('disabled');
        triggerBtn.classList.add('has-error');
        setTimeout(function () {
          triggerBtn.classList.remove('has-error');
        }, 2000);
      });
  }

  /**
   * The back-in-stock trigger Klaviyo injects next to the main add-to-cart button, which is
   * what the product page's own out-of-stock button clicks. Looked up on demand rather than
   * cached: Klaviyo injects it after load, and product-swatch.js tears it down and rebuilds
   * it on every colour change.
   */
  function findKlaviyoTrigger() {
    var triggers = document.querySelectorAll('.klaviyo-bis-trigger');
    for (var i = 0; i < triggers.length; i++) {
      if (!triggers[i].closest('#cart-bar')) return triggers[i];
    }
    return null;
  }

  /**
   * Open the back-in-stock form for the product on screen.
   *
   * Borrowing the product page's own trigger is preferred, because then this button and that
   * one are literally the same behaviour. But it is not always there to borrow: a colour
   * swatch swap removes it, and product-swatch.js only rebuilds it once a sold-out size has
   * actually been picked — so between the swap and that pick there is no trigger on the page
   * at all, and the bar still has a sold-out product to take signups for. Fall back to the
   * opener that file exposes, which reads the current product rather than the one Klaviyo
   * captured at load.
   */
  function openKlaviyoNotifyForm(notifyBtn) {
    var trigger = findKlaviyoTrigger();
    if (trigger) {
      trigger.click();
      return;
    }
    if (window.MalbonBackInStock) {
      // No variant id: nothing is selected yet in the state that gets us here, so the form
      // opens on the first of the sold-out sizes for the visitor to change.
      window.MalbonBackInStock.open(
        document.querySelector('[data-section-type="product"]'),
        null,
        notifyBtn
      );
    }
  }

  function init() {
    if (initialized) return;
    initialized = true;

    /*
     * Out-of-stock notify — capture so the theme cart-bar handler does not run.
     *
     * The theme answers this button by clicking the first `[data-popup-open]` in the product
     * section, which was its own sold-out notification modal. This store collects those
     * signups through Klaviyo instead, so that modal is hidden outright and the selector
     * either lands on an unrelated popup link or on nothing, in which case the theme throws
     * on the null and the button does nothing at all. Send the click to Klaviyo's trigger,
     * which is what the main out-of-stock button already does.
     */
    document.addEventListener(
      'click',
      function (e) {
        var notifyBtn = e.target.closest('[data-cart-bar-product-notification]');
        if (!notifyBtn || !notifyBtn.closest('#cart-bar')) return;
        // Coming-soon products keep the theme's scroll: their signup is a different Klaviyo
        // form, opened by the button this scrolls the page up to.
        if (notifyBtn.hasAttribute('data-cart-bar-scroll')) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        openKlaviyoNotifyForm(notifyBtn);
      },
      true
    );

    /* Single-variant direct add — capture so theme cart-bar handler does not run */
    document.addEventListener(
      'click',
      function (e) {
        var directBtn = e.target.closest('[data-cart-bar-direct-add]');
        if (!directBtn || !directBtn.closest('#cart-bar')) return;

        var form = document.querySelector('#cart-bar [data-cart-bar-add-form]');
        if (!form) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        cartBarFetchAdd(form, directBtn);
      },
      true
    );

    document.addEventListener('click', function (e) {
      var pickerBtn = e.target.closest('[data-cart-bar-variant-picker]');
      if (pickerBtn) {
        e.preventDefault();
        e.stopPropagation();
        var popup = getPopup();
        if (popup) setPickerOpen(popup.hidden);
        return;
      }

      if (e.target.closest('[data-cart-bar-variant-picker-close]')) {
        setPickerOpen(false);
        return;
      }

      var popup = getPopup();
      if (popup && !popup.hidden) {
        var openBtn = getPickerBtn();
        if (!popup.contains(e.target) && (!openBtn || !openBtn.contains(e.target))) {
          setPickerOpen(false);
        }
      }

      var variantBtn = e.target.closest('[data-cart-bar-variant-add]');
      if (!variantBtn || variantBtn.disabled || variantBtn.classList.contains('is-loading')) {
        return;
      }

      var form = variantBtn.closest('form');
      if (!form) return;

      e.preventDefault();
      resetPickerItemStates();
      cartBarFetchAdd(form, variantBtn, function () {
        setPickerOpen(false);
      });
    });

    document.addEventListener('keydown', function (e) {
      var popup = getPopup();
      if (popup && !popup.hidden && e.key === 'Escape') setPickerOpen(false);
    });

    window.addEventListener('resize', function () {
      var popup = getPopup();
      if (popup && !popup.hidden) positionPopupAboveCartBar();
    });
  }

  /**
   * Swap cart bar + variant picker from a fetched product section (color swatch).
   */
  function updateFromSection(currentSection, newSection) {
    if (!currentSection || !newSection) return;

    var currentBar = currentSection.querySelector('#cart-bar');
    var newBar = newSection.querySelector('#cart-bar');
    if (!currentBar || !newBar) return;

    currentBar.replaceWith(newBar.cloneNode(true));

    var popupSel = '[data-cart-bar-variant-picker-popup]';
    var currentPopup = document.querySelector(popupSel);
    var newPopup = newSection.querySelector(popupSel);

    if (currentPopup) {
      if (newPopup) {
        currentPopup.replaceWith(newPopup.cloneNode(true));
      } else {
        currentPopup.remove();
      }
    } else if (newPopup) {
      var bar = currentSection.querySelector('#cart-bar');
      if (bar) bar.insertAdjacentElement('afterend', newPopup.cloneNode(true));
    }
  }

  window.MalbonCartBar = {
    init: init,
    updateFromSection: updateFromSection
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
